/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * angular imports
 */
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/**
 * OwlCarousel Imports.
 */
import { OwlOptions } from 'ngx-owl-carousel-o';

/**
 * model import
 */
import { NCP, NcpProduct, Product } from '../model/ncp.model';
import { AnalyticsInterface } from '../../analytics-event/analytics.model';
import { EVENT_NAME } from '../../analytics-event/analytics.constant';
import { AppearedCards } from '../../directives/intersection/appear.interface';

/**
 * service import
 */
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';

/**
 * Constant import
 */
import { NUMBERS, NCP_SUB_PRODUCT_CARD_TYPE, SCREEN_NAME, PRODUCT_TYPE_CONSTANT, SPLIT } from '../../constants/app.constants';

@Component({
  selector: 'app-ncp-card',
  templateUrl: './ncp-card.component.html',
  styleUrls: ['./ncp-card.component.scss']
})
export class NcpCardComponent implements OnInit {

  @Input() callingFrom: string;
  @Input() product: NCP;

  public containsSingleItem = false;
  public numbers = NUMBERS;
  public cardTypeConst = NCP_SUB_PRODUCT_CARD_TYPE;
  public screeName = SCREEN_NAME;
  public analyticsViewAllData: AnalyticsInterface;
  /**
* Owl carousel options.
*/
  public customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    navText: ['<i class="prv-slider position-absolute"></i>', '<i class="nxt-slider position-absolute"></i>'],
    nav: true,
    autoWidth: true,
    autoplay: false,
    margin: 10,
    responsive: {
      0: {
        items: 1.15
      },
      530: {
        items: 2.15
      },
      700: {
        items: 1.15
      }
    }
  };

  constructor(
    public mls: NewLanguageService,
    private dss: DataStorageService,
    private fcs: FunCollectionService,
    private router: Router) {
  }

  ngOnInit(): void {
    if (this.callingFrom) {
      this.analyticsViewAllData = {
        'event_name': EVENT_NAME.NCP_VIEW_ALL_CLICK,
        'product_type': PRODUCT_TYPE_CONSTANT.NCP,
        'product_type_id': Number(this.ncpId),
        'screen_name': this.callingFrom,
      };
    }
    this.fcs.detectScreenChanges();
  }

  /**
   * getter for single subproduct
   */
  get isSingleProduct(): boolean {
    return this.product && this.ncpProduct.ncp_product.length === NUMBERS.ONE;
  }

  /**
   * getter for ncp products
   */
  get ncpProduct(): any {
    return this.product.products[0];
  }

  /**
   * getter for ncpId
   */
  get ncpId(): number {
    return this.ncpProduct.product_type_id;
  }

  /**
   * getter for all ncp sub products
   */
  get ncpProducts(): NcpProduct[] {
    return this.ncpProduct.ncp_product;
  }

  /**
   * getter for template images
   */
  get templateImage(): any  {
    return this.ncpProduct.ncp_template.image;
  }

  /**
   * getter for  template colors
   */
  get templateColor(): any  {
    return this.ncpProduct.ncp_template.color;
  }

  /**
   * getter for template text
   */
  get templateText(): any  {
    return this.ncpProduct.ncp_template.text;
  }

  /**
   * @EventHandler navigate to NCP detail page
   */
  navigateToNcpDetail(): void {
    this.router.navigate([`/game/list/${this.ncpId}`]);
  }

  /**
   * Get the appeared card product type and id.
   */
  getAppearedIds(card: Product): string {
    return `${card.product_type}${SPLIT}${card.product_type_id}`;
  }

  /**
   * Collects all game card on the horizontal carousal appeared on the viewport.
   */
  onCardAppear(cards: AppearedCards): void {
    this.fcs.onHorizontalCardAppear(cards, this.callingFrom);
  }

}
